import {
  ListItem as MuiListItem,
  ListItemSecondaryAction,
  ListItemText,
  Switch,
} from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';
import { withShowable } from '../../../../../_global/lib/withShowable';
import { selectGrowthbook } from '../../../../../../store/selectors/ui-settings.selectors';
import { toggleDynamicFormsAllProductsFlag } from '../../../../../../store/actions';

const ListItem = withShowable(MuiListItem);

export const DynamicFormsToggleListItem = () => {
  const dispatch = useDispatch();
  const { prime_one_x_dynamic_fields } = useSelector(selectGrowthbook);

  function handleDynamicFormsAllProductsToggle() {
    dispatch(toggleDynamicFormsAllProductsFlag());
  }

  return (
    <ListItem>
      <ListItemText
        primary={
          <span
            className="contrast-text"
            style={{ textTransform: 'capitalize' }}
          >
            Prime One Dynamic Forms
          </span>
        }
        disableTypography
      />
      <ListItemSecondaryAction
        onClick={handleDynamicFormsAllProductsToggle}
        style={{ right: 0 }}
      >
        <Switch
          value={prime_one_x_dynamic_fields}
          checked={prime_one_x_dynamic_fields}
        />
      </ListItemSecondaryAction>
    </ListItem>
  );
};
